import { EmailInput, PasswordInput } from '@library/components/inputs';
import { LogInButton } from '@library/components/buttons';
import OneTap from '@bo-components/sign-in//OneTap';
import { getAdminUserAnalyticDetails } from '@bo-utils/analytics';
import logoUrl from '@library/assets/images/pp-logos/name-logo.svg';
import { useAnalytics } from '@bo-hooks/analytics/useAnalytics';
import { useLoginMutation } from '@bo-services/authenticationApi';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';

export const SignIn = () => {
  const [userName, setUserName] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();
  const [login, { isError, isSuccess, isLoading, error }] = useLoginMutation();
  const { identify } = useAnalytics();

  if (isLoading) {
    return null;
  }

  if (isSuccess) {
    navigate('/');
    return null;
  }

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    try {
      const userData = await login({
        admin_user: {
          email: userName,
          password
        }
      }).unwrap();

      const adminUserDetails = getAdminUserAnalyticDetails(userData);
      identify(adminUserDetails.id, adminUserDetails);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('Login failed');
    }
  };

  return (
    <div className="bg-soFresh-100 flex h-screen min-h-full w-screen flex-col content-center justify-center px-6 py-12 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <img
          className="mx-auto h-10 w-auto"
          src={logoUrl}
          alt="PrizePicks Logo"
        />
        <h2 className="text-soClean-100 mt-10 text-center text-3xl leading-9 tracking-tight">
          Log in to your company account
        </h2>
      </div>

      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <form onSubmit={handleSubmit}>
          <span className="font-book text-sm text-red-500">
            {isError && JSON.stringify(error)}
          </span>
          <div className="pt-7">
            <EmailInput
              id="email"
              value={userName}
              onValueChange={setUserName}
            />
          </div>
          <div className="pt-7">
            <PasswordInput
              id="password"
              value={password}
              onValueChange={setPassword}
            />
          </div>

          <div>
            <LogInButton disabled={isLoading} />
            {window.google?.accounts && !isLoading && <OneTap />}
          </div>
        </form>
      </div>
    </div>
  );
};
